import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#121212" },
    secondary: { main: "#72cfc8" },
    background: { default: "#f4f2ed", paper: "#ffffff" },
    text: { primary: "#121212", secondary: "#686863" },
  },
  typography: {
    fontFamily: '"Manrope", sans-serif',
    h1: { fontFamily: '"DM Serif Display", serif' },
    h2: { fontFamily: '"DM Serif Display", serif' },
    h3: { fontFamily: '"DM Serif Display", serif' },
    button: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
  },
  shape: { borderRadius: 0 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiCard: { styleOverrides: { root: { borderRadius: 0, boxShadow: "none" } } },
  },
});

export default theme;
